<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kmy5Xq/images/Cover.jpg?1684305909797" alt="This image is the cover for the book Trucks! Construction Vehicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trucks! Construction Vehicles
      </h1>
      <p class="bookDescription body article font2">
        <p>They can dig, push, lift, and haul--construction trucks can do it all! How many of these amazing trucks can you name? This book of bright, bold photos and simple facts explores the world of hard-working construction vehicles.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Anne Martin
      </h2>
      
      <p class="authorDescription body article">Lee Anne Martin lives in Seattle, Washington, with her family: one husband, three children, one dog, and three cats.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      © 2011 becker&mayer! LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2528e5e7